import React from 'react';
import { Button, Box, Typography, Avatar } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import ModalBtnImg from '../../../assets/images/ModalBtnImg.png'; // Adjust the path as needed
import { TranslationKeys } from '../../../i18n/locales/defaultResources';
import { useI18n } from '../../../hooks/useI18n';

type AppModalButtonProps = {
  onClick?: () => void;
  style?: React.CSSProperties;
};

const AppModalButton: React.FC<Readonly<AppModalButtonProps>> = ({
  onClick,
  style,
}) => {
  const { t } = useI18n();

  return (
    <Button
      disableElevation
      disableRipple
      fullWidth
      onClick={onClick}
      variant="contained"
      sx={{
        backgroundColor: (theme) => theme.palette.vpButtonModal?.positive,
        borderRadius: 1,
        p: 2,
        justifyContent: 'flex-start',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: (theme) => theme.palette.vpButtonModal.positive,
          opacity: 0.9,
        },
        ...style,
      }}
    >
      <Avatar
        variant="square"
        sx={{ height: '48px', width: 'auto' }}
        src={ModalBtnImg}
      />
      <Box sx={{ flex: 1, textAlign: 'left', ml: 1 }}>
        <Typography
          component="p"
          color="vpButtonModal.text"
          variant="appLabelRegular"
        >
          {t(TranslationKeys.varietyPlanner_Banner_title)}
        </Typography>
        <Typography component="p" color="vpButtonModal.text" variant="appH3">
          {t(TranslationKeys.varietyPlanner_Banner_subtitle)}
        </Typography>
      </Box>
      <Avatar
        sx={{
          bgcolor: 'questionsForm.formBlue',
          width: 28,
          height: 28,
          ml: 2,
          boxShadow: 'none',
        }}
      >
        <ArrowForwardIosIcon sx={{ color: 'appWhite', fontSize: 18 }} />
      </Avatar>
    </Button>
  );
};

export default AppModalButton;
